module.exports = __webpack_public_path__ + "img/black-russian.75184b99.jpg";